<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     :selected-data="selectedRol" :customCreateActions="[setupLoadDataPermisos]"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedRol" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :subTableColumn="'permisosRolesEntities'" :custom-update-actions="[setupLoadDataPermisos]"
                    @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else-if="view === 'actualizar' || view === 'crear'">
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedRol" :load-data="loadDataRol"
                           :entity="entity" :auth-token="authToken" :list-api="listApi" :queries="queries"
                           :customSaveData="customSaveData" :skipDefaultSave="true" @updateValues="setupUpdateValues">
      <component v-if="loadDataPermisos.length" :is="childFormComponent" :load-data="loadDataRol"
                 :loadDataPermisos="loadDataPermisos"
                 @updateLoadDataPermisos="(index)=>loadDataPermisos[index].checked = !loadDataPermisos[index].checked"
                 @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
  <template v-else>
    <component :is="subtableComponent" :selectedRol="selectedRol" @updateValues="setupUpdateValues"></component>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import RolesCrearActualizarComponent from "@/components/auth/components/RolesCrearActualizarComponent";
import PermisosRolSubtableComponent from "./components/PermisosRolSubtableComponent.vue";
import {useLayoutMain} from "@/layouts/main";
import {updateValues} from "@/layouts/main";
import {
  generateTextError,
  swal,
  useAPIRest,
  verifyHttpCode,
} from "@/common/constants";
import {listCollectionData} from "@/layouts/main";

/**
 * Componente para realizar CRUD a roles.
 * @vue-data {Array} customSaveData - Una lista de funciones personalizadas que serán ejecutadas cuando se cree o actualice un rol.
 * @vue-data {function} setupLoadDataPermisos - Una función que carga todos los permisos con su respectivo estado en checkboxes.
 */
export default {
  name: 'RolesCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    RolesCrearActualizarComponent,
    PermisosRolSubtableComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Roles',
      entity: {gender: 'm', value: 'rol'},
      childFormComponent: 'rolesCrearActualizarComponent',
      subtableComponent: 'permisosRolSubtableComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre'
        },
        'permisosRolesEntities': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'Permisos'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      },
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionPermisos = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedRol = ref({
      id: '',
      nombre: '',
      estado: ''
    });
    const loadDataRol = ref({
      nombre: ''
    });
    const loadDataPermisos = ref([]);
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_ROL_CREATE,
      list: process.env.VUE_APP_NEST_ROL_FINDALL,
      update: process.env.VUE_APP_NEST_ROL_UPDATE,
      updateState: process.env.VUE_APP_NEST_ROL_UPDATESTATE
    });

    const customSaveData = ref([
      async () => {
        let textoExitoso;
        textoExitoso = 'El rol fue ' + (view.value === 'crear' ? 'creado' : 'actualizado') + ' exitosamente!';
        const callbackCreateUpdate = async (resJSON) => {
          const {statusCode} = resJSON;
          const textoError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) {
            if (view.value === "crear"){
              for (const permiso of loadDataPermisos.value) {
                if(permiso.checked){
                  await useAPIRest(process.env.VUE_APP_NEST_PERMISOROL_CREATE + "?estado=" + +permiso.checked, 'POST', authToken.value, {
                    permiso_id: permiso.id,
                    rol_id: resJSON.id
                  })
                }
              }
            }
            else if (view.value === "actualizar"){
              for (const permiso of loadDataPermisos.value) {
                await useAPIRest(process.env.VUE_APP_NEST_PERMISOROL_UPDATESTATE + "?estado=" + +permiso.checked, 'PATCH', authToken.value, {
                  permiso_id: permiso.id,
                  rol_id: resJSON.id
                })
              }
            }
            await swal.fire(textoExitoso, '', 'success');
            await listCollectionData(listApi['list'], setupUpdateValues, authToken.value, paginate.value.page, queries.value.orderBy, queries.value.order, queries.value.criterion, queries.value.search).then((resJSON) => {
              const {statusCode} = resJSON;
              if (verifyHttpCode(statusCode, 'success')) view.value = 'listar';
            });
          } else await swal.fire(textoError, '', 'error');
          return resJSON;
        };
        if (view.value === 'crear') await useAPIRest(listApi['create'], 'POST', authToken.value, loadDataRol.value).then(async resJSON => await callbackCreateUpdate(resJSON));
        else await useAPIRest(listApi['update'].replace(':id', selectedRol.value.id), 'PATCH', authToken.value, loadDataRol.value).then(async resJSON => await callbackCreateUpdate(resJSON));
      }
    ]);

    const setupLoadDataPermisos = async () => {
      const permisos = await useAPIRest(process.env.VUE_APP_NEST_PERMISO_FINDALL, 'GET', authToken.value, undefined, {
        page: 1,
        orderBy: 'created_at',
        order: 'ASC',
        criterion: '',
        search: '',
        where: '',
        isPaginate: false
      });
      const permisosRol = await useAPIRest(process.env.VUE_APP_NEST_PERMISOROL_FINDALL, 'GET', authToken.value, undefined, {
        page: 1,
        orderBy: 'created_at',
        order: 'ASC',
        criterion: '',
        search: '',
        where: 'rol_id = "' + selectedRol.value.id + '" AND table.estado = 1',
        isPaginate: false
      });
      const checkboxes = [];
      for (const permiso of permisos) {
        let rolHasPermiso = false;
        for (const permisoRol of permisosRol) {
          if (permiso.nombre === permisoRol.permiso.nombre)
            rolHasPermiso = true;
        }
        if (rolHasPermiso)
          checkboxes.push({id: permiso.id, permiso_nombre: permiso.nombre, checked: true})
        else
          checkboxes.push({id: permiso.id, permiso_nombre: permiso.nombre, checked: false})
      }
      updateValues({["loadDataPermisos"]: checkboxes}, {"loadDataPermisos": loadDataPermisos})
    }
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedRol, loadDataRol, listApi);
    return {
      view,
      collectionData,
      collectionPermisos,
      authToken,
      selectedRol,
      loadDataRol,
      loadDataPermisos,
      customSaveData,
      listApi,
      paginate,
      queries,
      setupLoadDataPermisos,
      setupUpdateValues,
      cleanLoadSelectedData,
    };
  }
}
</script>